import React, {
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import { Link } from "react-router-dom";
import $ from "jquery";
import "datatables.net-bs4";
import { deleteProvider, useProviders } from "../../utils/provider";
import { UserContext } from "../../App";
import { NavItem, NavTabs } from "../layout/Nav";
import { verifyRight } from "../../utils/users";
import { StyledTr } from "./bookingContent"; // Import du StyledTr
import ActionsMenu from "../layout/ActionsMenu"; // Import du menu d'actions
import TrashIcon from "../icons/TrashIcon"; // Icône de suppressions
import SelectionActionsPopup from "../layout/SelectionActionsPopup";
import { OutlineButtonLink } from "../layout/OutlineButton"; // Pop-Up pour actions multiples

export default function ProviderContent() {
  const { userInfos } = useContext(UserContext);
  const [checked, setChecked] = useState([]);
  const { providers, loaded } = useProviders();
  const datatable = useRef(null);

  // Handle DataTable when data is loading
  useEffect(() => {
    if (datatable.current) {
      datatable.current.destroy();
      datatable.current = null;
    }

    if (loaded) {
      window.setTimeout(() => {
        datatable.current = $("#datatable").DataTable({
          retrieve: true,
          order: [[1, "asc"]],
          pageLength: 25,
          searching: true,
        });
      }, 1);
    }
  }, [providers, loaded]);

  // Handle checkboxes for multiple selection
  function handleCheckbox(e) {
    const { value, checked: isChecked } = e.target;

    if (isChecked) {
      setChecked((old) => [...old, value]);
    } else {
      setChecked((old) => old.filter((id) => id !== value));
    }
  }

  // Dynamic table generation with actions menu
  const datatableContent = useMemo(() => {
    return (
      <tbody>
        {providers.map((provider, index) => {
          // Handle actions for each provider
          let actions = [];

          if (verifyRight(userInfos, "provider", "update")) {
            actions.push({
              link: `/provider/${provider.id}`,
              label: "Modifier",
            });
          }

          if (verifyRight(userInfos, "provider", "delete")) {
            actions.push({
              label: "Supprimer",
              onClick: async () => {
                if (
                  !window.confirm("Voulez-vous vraiment supprimer ce client ?")
                )
                  return;
                await deleteProvider(userInfos, [provider.id]);
                window.location.reload();
              },
            });
          }

          return (
            <StyledTr
              key={provider.id}
              className={checked.includes(provider.id) ? "checked" : ""}
            >
              <td style={{ textAlign: "center" }}>
                <input
                  type="checkbox"
                  checked={checked.includes(provider.id)}
                  name="bulk_action"
                  value={provider.id}
                  onChange={handleCheckbox}
                />
              </td>
              <td>{index + 1}</td>
              <td>
                {provider
                  ? (provider.name || `${provider.firstname || ''} ${provider.lastname || ''}`.trim())
                  : "N/A"
                }
              </td>
              <td>{provider.email || "N/A"}</td>
              <td>{provider.tel || "N/A"}</td>
              <td>
                <ActionsMenu items={actions} />
              </td>
            </StyledTr>
          );
        })}
      </tbody>
    );
  }, [providers, userInfos, checked]);

  // Handle bulk deletions
  const handleDeleteProvider = useCallback(async () => {
    if (checked.length) {
      if (!window.confirm("Voulez-vous vraiment supprimer ces clients ?"))
        return;
      await deleteProvider(userInfos, checked);
      window.location.reload();
    }
  }, [checked, userInfos]);

  // Footer with multiple actions (example: delete)
  const PortletFooter = useMemo(() => {
    let actions = [];
    if (verifyRight(userInfos, "provider", "delete"))
      actions.push({
        label: <TrashIcon />,
        title: "Supprimer",
        onClick: handleDeleteProvider,
      });
    if (checked.length) {
      return (
        <SelectionActionsPopup
          selectedItemsLength={checked.length}
          resetChecked={() => setChecked([])}
          buttons={actions}
          items={[]}
        />
      );
    }
  }, [checked.length, handleDeleteProvider, userInfos]);

  // Rendu final
  if (!loaded) {
    return (
      <div className="kt-content kt-grid__item kt-grid__item--fluid">
        Chargement des fournisseurs...
      </div>
    );
  }

  return (
    <div className="body-container">
      <div className="title-container">
        <NavTabs className="titles">
          {verifyRight(userInfos, "provider", "read") && (
            <NavItem className="active">
              <Link to="/provider">Clients</Link>
            </NavItem>
          )}
          {verifyRight(userInfos, "customer", "read") && (
            <NavItem>
              <Link to="/passenger">Passagers</Link>
            </NavItem>
          )}
        </NavTabs>
        <div className="header-toolbar">
          {verifyRight(userInfos, "provider", "create") && (
            <OutlineButtonLink to="/addProvider/">
              <i className="la la-plus"></i>
              Nouveau client
            </OutlineButtonLink>
          )}
        </div>
      </div>

      <div className="kt-container--fluid  kt-grid__item kt-grid__item--fluid">
        <div>
          <div className="kt-portlet__body" style={{ overflowX: "scroll" }}>
            <table
              className="table table-striped- table-bordered table-hover table-checkable"
              id="datatable"
            >
              <thead>
                <tr>
                  <th
                    style={{ width: "5%", textAlign: "center" }}
                    data-sort="false"
                  >
                    Select
                  </th>
                  <th style={{ width: "5%" }}>#</th>
                  <th style={{ width: "30%" }}>Nom</th>
                  <th style={{ width: "20%" }}>Mail</th>
                  <th style={{ width: "20%" }}>Tel</th>
                  <th style={{ width: "10%" }}>Action</th>
                </tr>
              </thead>
              {datatableContent}
            </table>
          </div>
          {PortletFooter}
        </div>
      </div>
    </div>
  );
}
